import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vente-moderne-container" }
const _hoisted_2 = { class: "row gx-3" }
const _hoisted_3 = { class: "col-lg-9" }
const _hoisted_4 = { class: "card vente-card mb-3" }
const _hoisted_5 = { class: "card-body p-3" }
const _hoisted_6 = { class: "row gx-2" }
const _hoisted_7 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_8 = { class: "form-group mb-2" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "form-group mb-2" }
const _hoisted_11 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_12 = { class: "form-group mb-2" }
const _hoisted_13 = {
  key: 2,
  class: "col-md-3"
}
const _hoisted_14 = { class: "form-group mb-2" }
const _hoisted_15 = {
  key: 3,
  class: "col-md-3"
}
const _hoisted_16 = { class: "form-group mb-2" }
const _hoisted_17 = {
  key: 4,
  class: "col-md-3"
}
const _hoisted_18 = { class: "form-group mb-2" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "form-group mb-2" }
const _hoisted_21 = { class: "d-block text-black" }
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = { class: "form-group mb-2" }
const _hoisted_24 = { class: "card vente-card mb-3" }
const _hoisted_25 = { class: "card-header vente-card-header d-flex justify-content-between align-items-center" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "card-body p-3" }
const _hoisted_28 = { class: "row gx-2 mb-3" }
const _hoisted_29 = { class: "col-md-5" }
const _hoisted_30 = {
  key: 0,
  class: "text-warning small"
}
const _hoisted_31 = {
  key: 1,
  class: "invalid-feedback d-block"
}
const _hoisted_32 = { class: "col-md" }
const _hoisted_33 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_34 = { class: "col-md" }
const _hoisted_35 = {
  class: "d-block text-black",
  title: "Prix Unitaire"
}
const _hoisted_36 = ["title"]
const _hoisted_37 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_38 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_39 = { class: "mt-1" }
const _hoisted_40 = { class: "text-muted" }
const _hoisted_41 = { class: "text-muted ms-3" }
const _hoisted_42 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_43 = {
  key: 1,
  class: "col-auto"
}
const _hoisted_44 = {
  key: 0,
  class: "row gx-2 mb-2 px-2 py-1 bg-light border rounded"
}
const _hoisted_45 = { class: "col" }
const _hoisted_46 = { class: "fw-semibold text-dark fs-13" }
const _hoisted_47 = { class: "col" }
const _hoisted_48 = { class: "fw-semibold text-dark fs-13" }
const _hoisted_49 = { class: "col" }
const _hoisted_50 = { class: "fw-semibold text-dark fs-13" }
const _hoisted_51 = { class: "col" }
const _hoisted_52 = { class: "fw-semibold text-dark fs-13" }
const _hoisted_53 = { class: "col" }
const _hoisted_54 = { class: "fw-semibold text-dark fs-13" }
const _hoisted_55 = { class: "col" }
const _hoisted_56 = { class: "fw-bold text-dark fs-14" }
const _hoisted_57 = {
  key: 1,
  class: "alert alert-danger py-1 mt-2",
  role: "alert"
}
const _hoisted_58 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_59 = {
  class: "tab-pane fade p-10",
  id: "home2-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "border border-primary mb-5" }
const _hoisted_62 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-2",
  style: {"background-color":"#0a59a4 !important"}
}
const _hoisted_63 = { class: "col-md-5" }
const _hoisted_64 = { class: "d-flex float-end" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = { class: "col-md-3 mb-5" }
const _hoisted_67 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_68 = { class: "col-md-3 mb-5" }
const _hoisted_69 = { class: "col-md-2 mb-5" }
const _hoisted_70 = { class: "col-md-2 mb-5" }
const _hoisted_71 = { class: "col-md-1 mb-5" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  key: 0,
  class: "card vente-card mb-3"
}
const _hoisted_74 = { class: "card-body p-3" }
const _hoisted_75 = {
  class: "mb-3",
  style: {"color":"#111827"}
}
const _hoisted_76 = {
  class: "badge rounded-pill",
  style: {"background-color":"#e5e7eb","color":"#6b7280","font-size":"0.875rem"}
}
const _hoisted_77 = { class: "table-responsive" }
const _hoisted_78 = { class: "table table-fixed text-nowrap align-middle mb-0 table-bordered" }
const _hoisted_79 = {
  key: 0,
  scope: "col",
  class: "magasin",
  title: "Magasin de stockage"
}
const _hoisted_80 = { class: "produit-col" }
const _hoisted_81 = { class: "fw-semibold" }
const _hoisted_82 = { class: "quantite-col" }
const _hoisted_83 = { class: "prix-unitaire-col" }
const _hoisted_84 = { class: "taxe-col" }
const _hoisted_85 = { class: "taxe-col" }
const _hoisted_86 = { class: "taxe-col" }
const _hoisted_87 = { class: "type-rse-col" }
const _hoisted_88 = { class: "vente-rse-col" }
const _hoisted_89 = { class: "taxe-col" }
const _hoisted_90 = { class: "taxe-col" }
const _hoisted_91 = { class: "taxe-col" }
const _hoisted_92 = { class: "taxe-col" }
const _hoisted_93 = {
  key: 0,
  class: "magasin-col"
}
const _hoisted_94 = { class: "actions-col pe-0" }
const _hoisted_95 = { class: "button-container d-flex gap-1" }
const _hoisted_96 = ["onClick"]
const _hoisted_97 = ["onClick"]
const _hoisted_98 = ["onClick"]
const _hoisted_99 = {
  key: 1,
  class: "card vente-card mb-3"
}
const _hoisted_100 = { class: "card-body p-3" }
const _hoisted_101 = {
  class: "mb-3",
  style: {"color":"#111827"}
}
const _hoisted_102 = {
  class: "badge rounded-pill",
  style: {"background-color":"#e5e7eb","color":"#6b7280","font-size":"0.875rem"}
}
const _hoisted_103 = { class: "col-lg-3" }
const _hoisted_104 = {
  class: "card vente-card recapitulatif-card sticky-lg-top",
  style: {"top":"80px"}
}
const _hoisted_105 = { class: "card-body p-3" }
const _hoisted_106 = { class: "recap-table mb-3" }
const _hoisted_107 = { class: "recap-row" }
const _hoisted_108 = { class: "recap-value" }
const _hoisted_109 = { class: "recap-row" }
const _hoisted_110 = { class: "recap-value" }
const _hoisted_111 = { class: "recap-row" }
const _hoisted_112 = { class: "recap-value" }
const _hoisted_113 = { class: "recap-row" }
const _hoisted_114 = { class: "recap-value" }
const _hoisted_115 = { class: "recap-row" }
const _hoisted_116 = { class: "recap-value" }
const _hoisted_117 = { class: "recap-row recap-ttc" }
const _hoisted_118 = { class: "recap-value fw-bold" }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { class: "form-group mb-2" }
const _hoisted_121 = { class: "input-group" }
const _hoisted_122 = ["data-bs-toggle", "data-bs-target", "disabled"]
const _hoisted_123 = {
  key: 0,
  class: "text-warning d-block mt-1"
}
const _hoisted_124 = {
  key: 1,
  class: "text-warning d-block mt-1"
}
const _hoisted_125 = { class: "form-group mb-2" }
const _hoisted_126 = { class: "form-group mb-3" }
const _hoisted_127 = { class: "action-buttons-group" }
const _hoisted_128 = ["disabled"]
const _hoisted_129 = ["disabled"]
const _hoisted_130 = {
  key: 0,
  class: "fa fa-print"
}
const _hoisted_131 = {
  key: 1,
  class: "fa fa-spinner fa-spin"
}
const _hoisted_132 = {
  class: "modal fade",
  id: "stockDetailsModal",
  tabindex: "-1",
  "aria-labelledby": "stockDetailsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_133 = {
  class: "modal-dialog modal-lg",
  style: {"display":"flex","align-items":"center","min-height":"calc(100vh - 1rem)","margin":"0.5rem auto"}
}
const _hoisted_134 = { class: "modal-content" }
const _hoisted_135 = { class: "modal-body" }
const _hoisted_136 = { class: "row mb-3" }
const _hoisted_137 = { class: "col-12" }
const _hoisted_138 = { class: "row mb-3" }
const _hoisted_139 = { class: "col-md-3" }
const _hoisted_140 = { class: "col-md-3" }
const _hoisted_141 = { class: "col-md-3" }
const _hoisted_142 = { class: "col-md-3" }
const _hoisted_143 = { class: "row mb-3" }
const _hoisted_144 = { class: "col-md-3" }
const _hoisted_145 = { class: "col-md-3" }
const _hoisted_146 = { class: "col-md-3" }
const _hoisted_147 = { class: "col-md-3" }
const _hoisted_148 = { class: "row mb-3" }
const _hoisted_149 = { class: "col-md-3" }
const _hoisted_150 = { class: "col-md-3" }
const _hoisted_151 = { class: "col-md-3" }
const _hoisted_152 = { class: "col-md-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_BilletageModal = _resolveComponent("BilletageModal")!
  const _component_AddInfoRemiseModal = _resolveComponent("AddInfoRemiseModal")!
  const _component_AddClientModal = _resolveComponent("AddClientModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.addVente,
      "validation-schema": _ctx.venteSchema,
      "keep-values": _ctx.valuess
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "card-header vente-card-header" }, [
                _createElementVNode("i", { class: "fa fa-info-circle me-2" }),
                _createTextVNode("Nouvelle commande ")
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.typeFacture !== 'Facture proforma')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block text-black" }, [
                            _createTextVNode("Type Commande "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _createVNode(_component_Field, {
                            name: "typeCommande",
                            modelValue: _ctx.typeC,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.typeC) = $event))
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_Multiselect, _mergeProps({
                                options: ['Au comptoir', 'Sur commande'],
                                searchable: true,
                                "track-by": "label",
                                label: "label",
                                modelValue: field.value,
                                "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                              }, field, {
                                placeholder: "Sélectionner",
                                onSelect: ($event: any) => (_ctx.showHide(field.value))
                              }), null, 16, ["modelValue", "onUpdate:modelValue", "onSelect"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "groupeTaxe",
                            class: "text-danger"
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black" }, [
                        _createTextVNode("Type Facture "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "typeFacture",
                        modelValue: _ctx.typeFacture,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.typeFacture) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: ['Facture de vente','Facture de vente à l\'exportation','Facture proforma'],
                            searchable: true,
                            "track-by": "label",
                            label: "label",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "typeFacture",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  (_ctx.typeFacture === 'Facture de vente à l\'exportation')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[35] || (_cache[35] = _createElementVNode("label", { class: "d-block text-black" }, [
                            _createTextVNode("Pays d'origine "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _createVNode(_component_Field, {
                            name: "paysOrigine",
                            modelValue: _ctx.paysOrigine,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paysOrigine) = $event))
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_Multiselect, _mergeProps({
                                options: _ctx.getPaysOrigineOptions,
                                searchable: true,
                                "track-by": "label",
                                label: "label",
                                modelValue: field.value,
                                "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                              }, field, { placeholder: "Pays d'origine" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "paysOrigine",
                            class: "text-danger"
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.paysOrigine)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _cache[36] || (_cache[36] = _createElementVNode("label", { class: "d-block text-black" }, "Lieu de chargement", -1)),
                          _createVNode(_component_Field, {
                            modelValue: _ctx.lieuChargement,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lieuChargement) = $event)),
                            name: "lieuChargement",
                            type: "text",
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.typeFacture === 'Facture de vente à l\'exportation')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _cache[37] || (_cache[37] = _createElementVNode("label", { class: "d-block text-black" }, [
                            _createTextVNode("Pays de destination "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _createVNode(_component_Field, {
                            name: "paysDestination",
                            modelValue: _ctx.paysDestination,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paysDestination) = $event))
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_Multiselect, _mergeProps({
                                options: _ctx.getPaysDestinationOptions,
                                searchable: true,
                                "track-by": "label",
                                label: "label",
                                modelValue: field.value,
                                "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                              }, field, { placeholder: "Pays de destination" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "paysDestination",
                            class: "text-danger"
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.paysDestination)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _cache[38] || (_cache[38] = _createElementVNode("label", { class: "d-block text-black" }, "Lieu de déchargement", -1)),
                          _createVNode(_component_Field, {
                            modelValue: _ctx.lieuDechargement,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.lieuDechargement) = $event)),
                            name: "lieuDechargement",
                            type: "text",
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, [
                        _cache[41] || (_cache[41] = _createTextVNode(" Client ")),
                        _cache[42] || (_cache[42] = _createElementVNode("span", { class: "text-danger" }, "*", -1)),
                        (!_ctx.selectedClient)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              style: {"float":"right"},
                              class: "btn btn-success me-3 btn-xs b-r-6",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#AddClientModal",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleAbonne && _ctx.toggleAbonne(...args)))
                            }, _cache[39] || (_cache[39] = [
                              _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        (_ctx.selectedClient)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              style: {"float":"right"},
                              class: "btn btn-success me-3 btn-xs",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleAbonne && _ctx.toggleAbonne(...args)))
                            }, _cache[40] || (_cache[40] = [
                              _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                              _createTextVNode(" Rechercher un client ")
                            ])))
                          : _createCommentVNode("", true)
                      ]),
                      (!_ctx.selectedClient)
                        ? (_openBlock(), _createBlock(_component_Field, {
                            key: 0,
                            name: "client"
                          }, {
                            default: _withCtx(({ field, handleChange }) => [
                              _createVNode(_component_Multiselect, {
                                options: _ctx.clientOptions,
                                searchable: true,
                                "track-by": "label",
                                label: "label",
                                "model-value": _ctx.clientCharger,
                                "onUpdate:modelValue": (v) => { _ctx.clientCharger = v; handleChange(v); },
                                placeholder: "Sélectionner le client"
                              }, null, 8, ["options", "model-value", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_Field, {
                            key: 1,
                            name: "client",
                            modelValue: _ctx.selectedClientId,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedClientId) = $event))
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_Multiselect, {
                                modelValue: field.value,
                                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                options: _ctx.clientsOps,
                                placeholder: "Sélectionner un client"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])),
                      _createVNode(_component_ErrorMessage, {
                        name: "client",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[43] || (_cache[43] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "TAUX AIB", -1)),
                      _createVNode(_component_Field, {
                        name: "tauxAIB",
                        modelValue: _ctx.valeurAib,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.valeurAib) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: ['1', '5'],
                            searchable: true,
                            "track-by": "label",
                            label: "label",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Choisir" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "tauxAIB",
                        class: "text-danger"
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[46] || (_cache[46] = _createElementVNode("span", { class: "header-title-only" }, null, -1)),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn-add-product", { 'btn-add-product-disabled': _ctx.isDisable }]),
                  type: "button",
                  disabled: _ctx.isDisable,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addRowProduit()))
                }, [
                  _cache[45] || (_cache[45] = _createElementVNode("i", { class: "fa fa-plus-circle me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.enModification ? 'Mettre à jour le produit' : 'Ajouter un produit'), 1)
                ], 10, _hoisted_26)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[48] || (_cache[48] = _createElementVNode("label", { class: "d-block text-black" }, [
                      _createTextVNode("Produit"),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Multiselect, {
                      options: _ctx.produitOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: _ctx.produit.produit,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.produit.produit) = $event)),
                      placeholder: "Sélectionnez le produit",
                      disabled: !_ctx.clientCharger,
                      onSelect: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectProd(_ctx.produit.produit, _ctx.produit))),
                      onOpen: _ctx.checkClientBeforeOpenProduit
                    }, null, 8, ["options", "modelValue", "disabled", "onOpen"]),
                    (!_ctx.clientCharger)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, _cache[47] || (_cache[47] = [
                          _createElementVNode("i", { class: "fa fa-info-circle me-1" }, null, -1),
                          _createTextVNode("Veuillez d'abord sélectionner un client ")
                        ])))
                      : _createCommentVNode("", true),
                    (_ctx.validateRowProduit(_ctx.produit.produit))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Champ obligatoire"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[49] || (_cache[49] = _createElementVNode("label", {
                      class: "d-block text-black",
                      title: "Quantité du produit"
                    }, [
                      _createTextVNode("Qte"),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.produit.qtite) = $event)),
                      class: _normalizeClass(_ctx.validateRowProduit(_ctx.produit.qtite) ? 'form-control is-invalid' : 'form-control'),
                      placeholder: "Quantité",
                      onKeyup: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.eventProduit && _ctx.eventProduit(...args)))
                    }, null, 34), [
                      [
                        _vModelText,
                        _ctx.produit.qtite,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    (_ctx.validateRowProduit(_ctx.produit.qtite))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Champ obligatoire"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, [
                      _cache[50] || (_cache[50] = _createTextVNode(" PU")),
                      _cache[51] || (_cache[51] = _createElementVNode("span", { class: "text-danger" }, "*", -1)),
                      (_ctx.produit.prixMin && _ctx.produit.prixMax)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "fa fa-info-circle text-muted ms-1",
                            title: `Prix recommandé: ${_ctx.produit.prixMin} - ${_ctx.produit.prixMax}`,
                            style: {"font-size":"12px","cursor":"help"}
                          }, null, 8, _hoisted_36))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.produit.prixTtc) = $event)),
                      class: _normalizeClass(_ctx.validateRowProduit(_ctx.produit.prixTtc) ? 'form-control is-invalid' : 'form-control'),
                      placeholder: "Prix",
                      onKeyup: _cache[16] || (_cache[16] = ($event: any) => {_ctx.onPrixManuelChange(); _ctx.eventProduit()}),
                      onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.validatePrixUnitaire && _ctx.validatePrixUnitaire(...args)))
                    }, null, 34), [
                      [
                        _vModelText,
                        _ctx.produit.prixTtc,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    (_ctx.validateRowProduit(_ctx.produit.prixTtc))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Champ obligatoire"))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.moduleGStockActif)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _cache[54] || (_cache[54] = _createElementVNode("label", {
                          class: "d-block text-black",
                          title: "Magasin de stockage"
                        }, "Magasin", -1)),
                        _createVNode(_component_Multiselect, {
                          options: _ctx.magasin1Options,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: _ctx.produit.magasin,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.produit.magasin) = $event)),
                          placeholder: "Sélectionner",
                          onSelect: _cache[19] || (_cache[19] = ($event: any) => (_ctx.updateStockByMagasin(_ctx.produit)))
                        }, null, 8, ["options", "modelValue"]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("small", _hoisted_40, [
                            _cache[52] || (_cache[52] = _createTextVNode("Logique: ")),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.produit.stockLogique || 0), 1)
                          ]),
                          _createElementVNode("small", _hoisted_41, [
                            _cache[53] || (_cache[53] = _createTextVNode("Physique: ")),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.produit.stockPhysique || 0), 1)
                          ])
                        ]),
                        (_ctx.validateRowProduit(_ctx.produit.magasin))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Champ obligatoire"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.moduleGStockActif)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, _cache[55] || (_cache[55] = [
                        _createElementVNode("label", {
                          class: "d-block",
                          style: {"visibility":"hidden"}
                        }, "Action", -1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-info d-flex align-items-center justify-content-center",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#AddInfoRemiseModal",
                          title: "Ajouter remise et taxe",
                          style: {"height":"40px","width":"40px","padding":"0"}
                        }, [
                          _createElementVNode("i", { class: "fa fa-plus-circle" })
                        ], -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.produit.produit && _ctx.produit.qtite > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _cache[56] || (_cache[56] = _createElementVNode("label", { class: "text-muted mb-0 fs-12" }, "Prix HT", -1)),
                        _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.produit.prixHt || 0), 1)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _cache[57] || (_cache[57] = _createElementVNode("label", { class: "text-muted mb-0 fs-12" }, "Montant HT", -1)),
                        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.produit.montantHt || 0), 1)
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _cache[58] || (_cache[58] = _createElementVNode("label", { class: "text-muted mb-0 fs-12" }, "Remise", -1)),
                        _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.produit.remise || 0), 1)
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _cache[59] || (_cache[59] = _createElementVNode("label", { class: "text-muted mb-0 fs-12" }, "HT après RSE", -1)),
                        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.produit.montantHtApresRemise || 0), 1)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _cache[60] || (_cache[60] = _createElementVNode("label", { class: "text-muted mb-0 fs-12" }, "TVA", -1)),
                        _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.produit.montantTva || 0), 1)
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _cache[61] || (_cache[61] = _createElementVNode("label", { class: "text-muted mb-0 fs-12" }, "TTC", -1)),
                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.produit.montantTtc || 0), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.prixErrorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      _cache[62] || (_cache[62] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.prixErrorMessage), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _cache[64] || (_cache[64] = _createElementVNode("div", { class: "col-md-7" }, [
                            _createElementVNode("h3", { class: "fs-4 text-white" }, "Entête de la facture")
                          ], -1)),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisableElement }]),
                                type: "button",
                                disabled: _ctx.isDisableElement,
                                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addRowElement && _ctx.addRowElement(...args)))
                              }, _cache[63] || (_cache[63] = [
                                _createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1),
                                _createTextVNode(" Ajouter une entête ")
                              ]), 10, _hoisted_65)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[66] || (_cache[66] = _createElementVNode("div", { class: "row d-flex align-items-center justify-content-between mt-10" }, [
                            _createElementVNode("div", { class: "col-md-3" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                _createTextVNode("Titre "),
                                _createElementVNode("span", { class: "text-danger" }, "*")
                              ])
                            ]),
                            _createElementVNode("div", { class: "col-md-3" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Description")
                            ]),
                            _createElementVNode("div", { class: "col-md-2" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                _createTextVNode("Taille police "),
                                _createElementVNode("span", { class: "text-danger" }, "*")
                              ])
                            ]),
                            _createElementVNode("div", { class: "col-md-3" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                _createTextVNode("Alignement "),
                                _createElementVNode("span", { class: "text-danger" }, "*")
                              ])
                            ]),
                            _createElementVNode("div", { class: "col-md-1" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Action")
                            ])
                          ], -1)),
                          _cache[67] || (_cache[67] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (element, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "row mb-5",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_66, [
                                _createVNode(_component_Field, {
                                  name: "titre",
                                  type: "text",
                                  modelValue: element.titre,
                                  "onUpdate:modelValue": ($event: any) => ((element.titre) = $event),
                                  class: "form-control shadow-none fs-md-15 text-black",
                                  placeholder: "Entrer le titre"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                (_ctx.validateRowElement(element.titre))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, "Le titre est obligatoire."))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_68, [
                                _createVNode(_component_Field, {
                                  name: "description",
                                  type: "text",
                                  modelValue: element.description,
                                  "onUpdate:modelValue": ($event: any) => ((element.description) = $event),
                                  class: "form-control shadow-none fs-md-15 text-black",
                                  placeholder: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_69, [
                                _createVNode(_component_Field, {
                                  name: "taillePolice",
                                  type: "number",
                                  modelValue: element.taillePolice,
                                  "onUpdate:modelValue": ($event: any) => ((element.taillePolice) = $event),
                                  class: "form-control shadow-none fs-md-15 text-black",
                                  placeholder: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_70, [
                                _createVNode(_component_Multiselect, {
                                  options: ['Centre', 'Gauche', 'Droite'],
                                  searchable: true,
                                  "track-by": "label",
                                  label: "label",
                                  modelValue: element.alignement,
                                  "onUpdate:modelValue": ($event: any) => ((element.alignement) = $event),
                                  placeholder: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _createElementVNode("button", {
                                  class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.removeRowElement(index))
                                }, _cache[65] || (_cache[65] = [
                                  _createElementVNode("i", { class: "icofont icofont-ui-delete" }, null, -1)
                                ]), 8, _hoisted_72)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            (_ctx.produits.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("h5", _hoisted_75, [
                      _cache[68] || (_cache[68] = _createElementVNode("i", { class: "fa fa-list me-2" }, null, -1)),
                      _cache[69] || (_cache[69] = _createTextVNode("Produits sélectionnés ")),
                      _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.produits.length), 1)
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("table", _hoisted_78, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _cache[70] || (_cache[70] = _createElementVNode("th", {
                              scope: "col",
                              class: "produit info",
                              title: "Produit sélectionné"
                            }, "Produit", -1)),
                            _cache[71] || (_cache[71] = _createElementVNode("th", {
                              scope: "col",
                              class: "quantite",
                              title: "Quantité du produit"
                            }, "Qte", -1)),
                            _cache[72] || (_cache[72] = _createElementVNode("th", {
                              scope: "col",
                              class: "prix-unitaire",
                              title: "Prix Unitaire"
                            }, "PU", -1)),
                            _cache[73] || (_cache[73] = _createElementVNode("th", {
                              scope: "col",
                              title: "Prix Hors Taxe"
                            }, "Prix HT", -1)),
                            _cache[74] || (_cache[74] = _createElementVNode("th", {
                              scope: "col",
                              title: "Montant Hors Taxe"
                            }, "MT HT", -1)),
                            _cache[75] || (_cache[75] = _createElementVNode("th", {
                              scope: "col",
                              class: "taxe",
                              title: "Taxe Spécifique"
                            }, "Taxe S.", -1)),
                            _cache[76] || (_cache[76] = _createElementVNode("th", {
                              scope: "col",
                              class: "type-rse",
                              title: "Type de Remise, Solde ou Escompte"
                            }, "Type RSE", -1)),
                            _cache[77] || (_cache[77] = _createElementVNode("th", {
                              scope: "col",
                              class: "vente-rse",
                              title: "Vente normale ou Remise, Solde, Escompte"
                            }, "Vente/RSE", -1)),
                            _cache[78] || (_cache[78] = _createElementVNode("th", {
                              scope: "col",
                              title: "Montant de la Remise"
                            }, "MT Remise", -1)),
                            _cache[79] || (_cache[79] = _createElementVNode("th", {
                              scope: "col",
                              title: "Montant Hors Taxe Après Remise, Solde, Escompte"
                            }, "MT HT Ap RSE", -1)),
                            _cache[80] || (_cache[80] = _createElementVNode("th", {
                              scope: "col",
                              title: "Montant de la Taxe sur la Valeur Ajoutée"
                            }, "MT TVA", -1)),
                            _cache[81] || (_cache[81] = _createElementVNode("th", {
                              scope: "col",
                              class: "text pe-0",
                              title: "Montant Toutes Taxes Comprises"
                            }, "MT TTC", -1)),
                            (_ctx.moduleGStockActif)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_79, "Magasin"))
                              : _createCommentVNode("", true),
                            _cache[82] || (_cache[82] = _createElementVNode("th", {
                              scope: "col",
                              class: "actions pe-0",
                              title: "Actions disponibles sur cette ligne"
                            }, "Actions", -1))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_80, [
                                _createElementVNode("div", _hoisted_81, _toDisplayString(produit.libelleProduit), 1)
                              ]),
                              _createElementVNode("td", _hoisted_82, _toDisplayString(produit.qtite), 1),
                              _createElementVNode("td", _hoisted_83, _toDisplayString(produit.prixTtc), 1),
                              _createElementVNode("td", _hoisted_84, _toDisplayString(produit.prixHt), 1),
                              _createElementVNode("td", _hoisted_85, _toDisplayString(produit.montantHt), 1),
                              _createElementVNode("td", _hoisted_86, _toDisplayString(produit.taxeSpecifique), 1),
                              _createElementVNode("td", _hoisted_87, _toDisplayString(produit.typeRemise), 1),
                              _createElementVNode("td", _hoisted_88, _toDisplayString(produit.valeurRemise), 1),
                              _createElementVNode("td", _hoisted_89, _toDisplayString(produit.remise), 1),
                              _createElementVNode("td", _hoisted_90, _toDisplayString(produit.montantHtApresRemise), 1),
                              _createElementVNode("td", _hoisted_91, _toDisplayString(produit.montantTva), 1),
                              _createElementVNode("td", _hoisted_92, _toDisplayString(produit.montantTtc), 1),
                              (_ctx.moduleGStockActif)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_93, _toDisplayString(_ctx.getMagasinLabel(produit.magasin)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_94, [
                                _createElementVNode("div", _hoisted_95, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm",
                                    style: {"background-color":"#00bcd4","color":"white","border":"none","width":"32px","height":"32px","padding":"0","display":"inline-flex","align-items":"center","justify-content":"center"},
                                    onClick: ($event: any) => (_ctx.showDetails(produit)),
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#stockDetailsModal",
                                    title: "Voir détails"
                                  }, _cache[83] || (_cache[83] = [
                                    _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                                  ]), 8, _hoisted_96),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm",
                                    style: {"background-color":"#9e9e9e","color":"white","border":"none","width":"32px","height":"32px","padding":"0","display":"inline-flex","align-items":"center","justify-content":"center"},
                                    onClick: ($event: any) => (_ctx.editProduit(index)),
                                    title: "Modifier"
                                  }, _cache[84] || (_cache[84] = [
                                    _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
                                  ]), 8, _hoisted_97),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm",
                                    style: {"background-color":"#f56565","color":"white","border":"none","width":"32px","height":"32px","padding":"0","display":"inline-flex","align-items":"center","justify-content":"center"},
                                    onClick: ($event: any) => (_ctx.removeRowProduit(index)),
                                    title: "Supprimer"
                                  }, _cache[85] || (_cache[85] = [
                                    _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                                  ]), 8, _hoisted_98)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_99, [
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("h5", _hoisted_101, [
                      _cache[86] || (_cache[86] = _createElementVNode("i", { class: "fa fa-list me-2" }, null, -1)),
                      _cache[87] || (_cache[87] = _createTextVNode("Produits sélectionnés ")),
                      _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.produits.length), 1)
                    ]),
                    _cache[88] || (_cache[88] = _createElementVNode("div", { class: "table-responsive text-center" }, [
                      _createElementVNode("h5", {
                        class: "mb-0",
                        style: {"color":"#111827","font-size":"14px"}
                      }, [
                        _createElementVNode("i", { class: "fa fa-info-circle me-2" }),
                        _createTextVNode("Vos Produits sélectionnés s'afficheront ici ")
                      ])
                    ], -1))
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("div", _hoisted_104, [
              _cache[107] || (_cache[107] = _createElementVNode("div", { class: "card-header vente-card-header" }, [
                _createElementVNode("i", { class: "fa fa-calculator me-2" }),
                _createTextVNode("Récapitulatif ")
              ], -1)),
              _createElementVNode("div", _hoisted_105, [
                _createVNode(_component_Field, {
                  name: "dateCommande",
                  readonly: true,
                  value: _ctx.getCurrentDateTime(),
                  type: "datetime-local",
                  class: "form-control shadow-none fs-md-15 text-black d-none",
                  placeholder: ""
                }, null, 8, ["value"]),
                _createElementVNode("div", _hoisted_106, [
                  _createVNode(_component_Field, {
                    modelValue: _ctx.totalsomme,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.totalsomme) = $event)),
                    name: "montantHT",
                    type: "hidden"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.totalsommeremise,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.totalsommeremise) = $event)),
                    name: "montantHTRSE",
                    type: "hidden"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.totaltva,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.totaltva) = $event)),
                    name: "montantTVA",
                    type: "hidden"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.totalaib,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.totalaib) = $event)),
                    name: "montantAIB",
                    type: "hidden"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.totalts,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.totalts) = $event)),
                    name: "montantTS",
                    type: "hidden"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.totalttc,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.totalttc) = $event)),
                    name: "montantTTC",
                    type: "hidden"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_107, [
                    _cache[89] || (_cache[89] = _createElementVNode("span", { class: "recap-label" }, "Montant HT", -1)),
                    _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.totalsomme), 1)
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _cache[90] || (_cache[90] = _createElementVNode("span", { class: "recap-label" }, "Montant HT RSE", -1)),
                    _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.totalsommeremise), 1)
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _cache[91] || (_cache[91] = _createElementVNode("span", { class: "recap-label" }, "Montant TVA", -1)),
                    _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.totaltva), 1)
                  ]),
                  _createElementVNode("div", _hoisted_113, [
                    _cache[92] || (_cache[92] = _createElementVNode("span", { class: "recap-label" }, "Montant AIB", -1)),
                    _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.totalaib), 1)
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    _cache[93] || (_cache[93] = _createElementVNode("span", { class: "recap-label" }, "Taxe S.", -1)),
                    _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.totalts), 1)
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _cache[94] || (_cache[94] = _createElementVNode("span", { class: "recap-label fw-bold" }, "TOTAL TTC", -1)),
                    _createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.totalttc), 1)
                  ])
                ]),
                _cache[105] || (_cache[105] = _createElementVNode("hr", null, null, -1)),
                (_ctx.showC && _ctx.moduleBilletageActif)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                      _cache[100] || (_cache[100] = _createElementVNode("h6", { class: "text-black mb-2" }, [
                        _createElementVNode("i", { class: "fa fa-money-bill me-1" }),
                        _createTextVNode("Paiement")
                      ], -1)),
                      _createElementVNode("div", _hoisted_120, [
                        _cache[98] || (_cache[98] = _createElementVNode("label", { class: "d-block text-black" }, [
                          _createTextVNode("Montant Reçu "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_121, [
                          _createVNode(_component_Field, {
                            name: "montantReçu",
                            type: "text",
                            modelValue: _ctx.montantReçu,
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.montantReçu) = $event)),
                            modelModifiers: { number: true },
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: "Montant reçu",
                            readonly: ""
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary btn-md btn-calculator",
                            "data-bs-toggle": _ctx.clientCharger && _ctx.produits.length > 0 && _ctx.totalttc > 0 ? 'modal' : '',
                            "data-bs-target": _ctx.clientCharger && _ctx.produits.length > 0 && _ctx.totalttc > 0 ? '#billetagePaiementModal' : '',
                            onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.checkBeforeOpenBilletage && _ctx.checkBeforeOpenBilletage(...args))),
                            title: "Ouvrir le billetage",
                            disabled: !_ctx.clientCharger || _ctx.produits.length === 0 || _ctx.totalttc <= 0,
                            style: {"animation":"none !important","transform":"none !important","transition":"none !important"}
                          }, _cache[95] || (_cache[95] = [
                            _createElementVNode("i", { class: "fa fa-calculator" }, null, -1)
                          ]), 8, _hoisted_122)
                        ]),
                        (_ctx.clientCharger && _ctx.produits.length > 0 && _ctx.totalttc > 0 && _ctx.moduleBilletageActif && _ctx.showC && !_ctx.montantReçu)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_123, _cache[96] || (_cache[96] = [
                              _createElementVNode("i", { class: "fa fa-info-circle me-1" }, null, -1),
                              _createTextVNode("Veuillez cliquer sur la calculatrice pour régler ")
                            ])))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ErrorMessage, {
                          name: "montantReçu",
                          class: "text-danger"
                        }),
                        (_ctx.reliquatNonRendu > 0)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_124, [
                              _cache[97] || (_cache[97] = _createElementVNode("i", { class: "fa fa-exclamation-triangle" }, null, -1)),
                              _createTextVNode(" Reliquat non rendu: " + _toDisplayString(_ctx.reliquatNonRendu) + " Fcfa ", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_125, [
                        _cache[99] || (_cache[99] = _createElementVNode("label", { class: "d-block text-black" }, "Reliquat", -1)),
                        _createVNode(_component_Field, {
                          name: "reliquat",
                          modelValue: _ctx.reliquatAffiche,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.reliquatAffiche) = $event)),
                          readonly: true,
                          type: "text",
                          class: _normalizeClass(["form-control shadow-none fs-md-15 text-black", {
                      'text-success': _ctx.reliquatAffiche > 0,
                      'text-danger': _ctx.reliquatAffiche < 0
                    }])
                        }, null, 8, ["modelValue", "class"])
                      ]),
                      _cache[101] || (_cache[101] = _createElementVNode("hr", null, null, -1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_126, [
                  _cache[102] || (_cache[102] = _createElementVNode("label", { class: "d-block text-black" }, [
                    _createElementVNode("i", { class: "fa fa-print me-1" }),
                    _createTextVNode("Format d'impression")
                  ], -1)),
                  _createVNode(_component_Field, {
                    name: "formatImpression",
                    modelValue: _ctx.formatImpression,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formatImpression) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        options: ['A4', 'A5', 'A6', 'T1', 'T2'],
                        searchable: true,
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, { placeholder: "Format impression" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "formatImpression",
                    class: "text-danger"
                  })
                ]),
                _cache[106] || (_cache[106] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("div", _hoisted_127, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: _normalizeClass(["btn-modern btn-modern-primary", { 'btn-modern-disabled': _ctx.isDisable || (_ctx.moduleBilletageActif && _ctx.showC && _ctx.typeFacture !== 'Facture proforma' && (!_ctx.montantTotalEncaissement || _ctx.montantTotalEncaissement < _ctx.totalttc)) }]),
                    disabled: _ctx.isDisable || (_ctx.moduleBilletageActif && _ctx.showC && _ctx.typeFacture !== 'Facture proforma' && (!_ctx.montantTotalEncaissement || _ctx.montantTotalEncaissement < _ctx.totalttc))
                  }, _cache[103] || (_cache[103] = [
                    _createElementVNode("i", { class: "fa fa-save" }, null, -1),
                    _createTextVNode(" Enregistrer ")
                  ]), 10, _hoisted_128),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn-modern btn-modern-secondary", { 'btn-modern-disabled': _ctx.isDisable || _ctx.isGeneratingPdf || (_ctx.moduleBilletageActif && _ctx.showC && _ctx.typeFacture !== 'Facture proforma' && (!_ctx.montantTotalEncaissement || _ctx.montantTotalEncaissement < _ctx.totalttc)) }]),
                    disabled: _ctx.isDisable || _ctx.isGeneratingPdf || (_ctx.moduleBilletageActif && _ctx.showC && _ctx.typeFacture !== 'Facture proforma' && (!_ctx.montantTotalEncaissement || _ctx.montantTotalEncaissement < _ctx.totalttc)),
                    onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.handleSaveAndPrint && _ctx.handleSaveAndPrint(...args)))
                  }, [
                    (!_ctx.isGeneratingPdf)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_130))
                      : (_openBlock(), _createElementBlock("i", _hoisted_131)),
                    _createTextVNode(" " + _toDisplayString(_ctx.isGeneratingPdf ? 'Génération...' : 'Enregistrer et imprimer'), 1)
                  ], 10, _hoisted_129),
                  _createVNode(_component_router_link, {
                    to: "/ventes/liste-ventes",
                    class: "btn-modern btn-modern-danger"
                  }, {
                    default: _withCtx(() => _cache[104] || (_cache[104] = [
                      _createElementVNode("i", { class: "fa fa-times" }, null, -1),
                      _createTextVNode(" Annuler ")
                    ])),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema", "keep-values"]),
    _createElementVNode("div", _hoisted_132, [
      _createElementVNode("div", _hoisted_133, [
        _createElementVNode("div", _hoisted_134, [
          _cache[121] || (_cache[121] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", null, "Détails du produit"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_135, [
            _createElementVNode("div", _hoisted_136, [
              _createElementVNode("div", _hoisted_137, [
                _cache[108] || (_cache[108] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Produit :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.libelleProduit || 'Non défini'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_138, [
              _createElementVNode("div", _hoisted_139, [
                _cache[109] || (_cache[109] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Quantité :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.qtite || 'Non défini'), 1)
              ]),
              _createElementVNode("div", _hoisted_140, [
                _cache[110] || (_cache[110] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Prix unitaire :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.prixTtc || 'Non défini'), 1)
              ]),
              _createElementVNode("div", _hoisted_141, [
                _cache[111] || (_cache[111] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Prix HT :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.prixHt || 'Non défini'), 1)
              ]),
              _createElementVNode("div", _hoisted_142, [
                _cache[112] || (_cache[112] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Montant HT :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.montantHt || 'Non défini'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_143, [
              _createElementVNode("div", _hoisted_144, [
                _cache[113] || (_cache[113] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Taxe S. :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.taxeSpecifique || 'Non défini'), 1)
              ]),
              _createElementVNode("div", _hoisted_145, [
                _cache[114] || (_cache[114] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Type RSE :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.typeRemise || 'Non défini'), 1)
              ]),
              _createElementVNode("div", _hoisted_146, [
                _cache[115] || (_cache[115] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Valeur RSE :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.valeurRemise || 'Non défini'), 1)
              ]),
              _createElementVNode("div", _hoisted_147, [
                _cache[116] || (_cache[116] = _createElementVNode("p", { class: "fw-bold mb-1" }, "MT Remise :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.remise || 'Non défini'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_148, [
              _createElementVNode("div", _hoisted_149, [
                _cache[117] || (_cache[117] = _createElementVNode("p", { class: "fw-bold mb-1" }, "MT. HT Ap Rse :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.montantHtApresRemise || 'Non défini'), 1)
              ]),
              _createElementVNode("div", _hoisted_150, [
                _cache[118] || (_cache[118] = _createElementVNode("p", { class: "fw-bold mb-1" }, "MT. TVA :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.montantTva || 'Non défini'), 1)
              ]),
              _createElementVNode("div", _hoisted_151, [
                _cache[119] || (_cache[119] = _createElementVNode("p", { class: "fw-bold mb-1" }, "MT. TTC :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.selectedProduit?.montantTtc || 'Non défini'), 1)
              ]),
              _createElementVNode("div", _hoisted_152, [
                _cache[120] || (_cache[120] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Magasin :", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.getMagasinLabel(_ctx.selectedProduit?.magasin)), 1)
              ])
            ])
          ]),
          _cache[122] || (_cache[122] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Fermer")
          ], -1))
        ])
      ])
    ]),
    (_ctx.moduleBilletageActif)
      ? (_openBlock(), _createBlock(_component_BilletageModal, {
          key: 0,
          "billetage-list": _ctx.billetageList,
          "billetage-sortie-list": _ctx.billetageSortieList,
          totalttc: _ctx.totalttc,
          "billetage-error": _ctx.billetageError,
          onValidate: _ctx.handleBilletageValidation,
          "onUpdate:montantRecu": _cache[32] || (_cache[32] = (val) => _ctx.montantReçu = val)
        }, null, 8, ["billetage-list", "billetage-sortie-list", "totalttc", "billetage-error", "onValidate"]))
      : _createCommentVNode("", true),
    _createVNode(_component_AddInfoRemiseModal, {
      "type-remise": _ctx.produit.typeRemise,
      "valeur-remise": _ctx.produit.valeurRemise,
      "taxe-specifique": _ctx.produit.taxeSpecifique,
      onUpdate: _ctx.handleInfoRemiseUpdate
    }, null, 8, ["type-remise", "valeur-remise", "taxe-specifique", "onUpdate"]),
    _createVNode(_component_AddClientModal, { onGetclient: _ctx.getClient }, null, 8, ["onGetclient"])
  ]))
}